import Timestamp from "components/Timestamp";
import Box from "ds/components/Box";

import { VariableCellComponentProps } from "./types";

const TimestampCell = ({ variable }: VariableCellComponentProps) => {
  if (!variable.createdAt) {
    return null;
  }

  return (
    <Box align="center">
      <Timestamp timestamp={variable.createdAt ?? 0} />
    </Box>
  );
};

export default TimestampCell;
